(function() {
    angular.module('tmx-app')
        .controller('usersDynamicEditCtrl', ['$scope', 'resolvedData', 'LocationService', 'lookupService', '$state', '$mdDialog','dynamicform', UsersEditCtrl]);

    function UsersEditCtrl($scope, resolvedData, LocationService, lookupService, $state, $mdDialog, dynamicform) {
        var userVM = this;

    ///////////////////FUNCTIONS////////////////////////

        userVM.updateDevicePhoneNumber= function(deviceId){
            for(var i=0;i<userVM.Devices.length;i++) {
                if(userVM.Devices[i].HiddenValue==deviceId)
                    userVM.PhoneNumber = userVM.Devices[i].PhoneNumber;
            }
        }
        userVM.getLocationName = function(response, LocationId) {
            if (LocationId == null)
                return '---';
            else {
                for (var j = 0; j < response.length; j++) {
                    if (response[j].LocationId == LocationId)
                        return response[j].LocationName;
                }
            }
        };
        userVM.onEndDateSelected = function(day) {
            userVM.showStatus = true;
            var d = new Date(day);
            userVM.vm.EffectiveEndDate = d.toJSON();
            if (day != null)
                userVM.StartDateInvalid = false;
            else
                userVM.StartDateInvalid = true;
            var st = userVM.getStatus();
            userVM.currentStatus = st;
        };
        userVM.onStartDateSelected = function(day) {
            userVM.showStatus = true;
            var d = new Date(day);
            userVM.vm.EffectiveStartDate = d.toJSON();
            if (day != null)
                userVM.EndDateInvalid = false;
            else
                userVM.EndDateInvalid = true;
            var st = userVM.getStatus();
            userVM.currentStatus = st;
        };
        userVM.getStatus = function() {
            if (angular.isDefined(userVM.vm.EffectiveEndDate) && angular.isDefined(userVM.vm.EffectiveStartDate)) {
                if (userVM.vm.EffectiveEndDate > userVM.date && userVM.vm.EffectiveStartDate < userVM.date) {
                    return "Active";
                }
            }
            return "Inactive";
        }
        userVM.save = function() {
            userVM.loading=true;
            if(angular.isDefined(userVM.vm.TmxAddress) && angular.isDefined(userVM.vm.TmxAddress.TmXAddressGeography)) {
                userVM.vm.TmxAddress.TmXAddressGeography = undefined;
            }
            if (!angular.isDefined(userVM.vm.UserName))
                userVM.vm.UserName = userVM.vm.EmailAddress;
            userVM.vm.$saveOrUpdate().then(function(promise) {
        // $state.data.grid.userGrid.dataSource.read();
                userVM.loading=false;
                $state.searchClear = true;
                $state.go("^");
            });
        };
        userVM.saveAndNew = function() {
            userVM.loading=true;
            if(angular.isDefined(userVM.vm.TmxAddress) && angular.isDefined(userVM.vm.TmxAddress.TmXAddressGeography)) {
                userVM.vm.TmxAddress.TmXAddressGeography = undefined;
            }
            if (!angular.isDefined(userVM.vm.UserName))
                userVM.vm.UserName = userVM.vm.EmailAddress;
            userVM.vm.$saveOrUpdate().then(function(promise) {
        // $state.data.grid.userGrid.dataSource.read();
                userVM.loading=false;
                $state.searchClear = true;
                $state.go("^.add");
            });
        };
        userVM.cancel = function() {
            $state.searchClear = true;
            $state.go("^");
        };
        userVM.statusChange = function(item) {
        };
        userVM.locationTreeGridDialog = function(ev) {
            $mdDialog.show({
                locals: {
                    selectedItem: angular.copy(userVM.vm),
                    columns: userVM.columns,
                    gridData: userVM.gridData
                },
                controller: ["$scope", "$mdDialog", "$state", 'LocationService', 'selectedItem', 'gridData', 'columns',DialogController],
                controllerAs: 'LocationDialogCtrl',
                template: '<md-dialog ng-cloak flex="80" style="height:80%"><md-dialog-content><kendo-treelist id="grid" options="LocationDialogCtrl.mainGridOptions"></kendo-treelist>    </md-dialog-content></md-dialog>',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function(dataitem) {
                    userVM.vm.LocationName = dataitem.LocationName;
                    userVM.vm.LocationId = dataitem.LocationId;
                });
        };
        function DialogController($scope, $mdDialog, $state, LocationService, selectedItem, gridData,columns) {
            var obj = this;
            obj.mainGridOptions = {
                dataSource: {
                    data: gridData,
                    sort: [
                        {
                            field: "status",
                            dir: "asc"
                        }, 
                        {
                            field: "LocationName",
                            dir: "asc"
                        }, 
                        {
                            field: "LocationCode",
                            dir: "asc"
                        }
                    ],
                    schema: {
                        data: "data",
                        total: "Total",
                        model: {
                            id: "LocationId",
                            parentId: "ParentLocationId",
                            fields: {
                                LocationId: {
                                    type: "number",
                                    editable: false,
                                    nullable: false
                                },
                                TenantId: {
                                    nullable: true,
                                    type: "number"
                                },
                                ParentLocationId: {
                                    nullable: true,
                                    type: "number"
                                },
                                ParentLocationName: {
                                    nullable: true,
                                    type: "string"
                                },
                                LocationCode: {
                                    nullable: true,
                                    type: "string"
                                },
                                LocationName: {
                                    nullable: true,
                                    type: "string"
                                },
                                LocationTypeLkp: {
                                    nullable: true,
                                    type: "number"
                                },
                                status: {
                                    type: "string"
                                }
                            }
                        },
                        parse: function(response) {
                            var products = [];
                            for (var i = 0; i < response.length; i++) {
                // var getParentName = userVM.getLocationName;
                                var getStatus = function(EffectiveEndDate) {
                                    var currentDate = new Date();
                                    var endDate = kendo.parseDate(EffectiveEndDate);
                                    if ((endDate - currentDate) > 0)
                                        return 'Active';
                                    else
                                        return 'Inactive';
                                };
                                var product = {
                                    LocationId: response[i].LocationId,
                                    TenantId: response[i].TenantId,
                                    ParentLocationId: response[i].ParentLocationId,
                                    ParentLocationName: userVM.getLocationName(response, response[i].ParentLocationId),
                                    LocationCode: response[i].LocationCode,
                                    LocationName: response[i].LocationName,
                                    LocationTypeLkp: response[i].LocationTypeLkp,
                                    status: getStatus(response[i].EffectiveEndDate)
                                };
                                products.push(product);
                            }
                            products = {
                                data: products
                            };
                            return products;
                        }
                    },
                },
                pdf: {
                    allPages: true,
                    fileName: "Companies.pdf"
                },
                excel: {
                    allPages: true,
                    fileName: "Companies.xlsx"
                },
                sortable: true,
                resizable: true,
                scrollable: false,
                selectable: true,
                columns: columns
            };
            obj.mainGridOptions.dataBound = onDataBound;
            var selectedDataItem = null;
            obj.mainGridOptions.change = function(e) {
                var selectedRows = this.select();
                selectedDataItem = this.dataItem(selectedRows[0]);
                $scope.hide();
            };
            $scope.hide = function() {
                $mdDialog.hide(selectedDataItem);
            };
            $scope.cancel = function() {
                $mdDialog.cancel(selectedDataItem);
            };

            function onDataBound(arg) {
                selectedItem.ParentLocationId=selectedItem.LocationId;
                expandItem(arg.sender, selectedItem);
                applyClassOnRow(arg.sender, "LocationId", selectedItem.LocationId, "tmx-selected-bg");
            }

            function applyClassOnRow(kendoGrid, attrName, attrValue, className) {
                var list = kendoGrid.dataItems();
                var items = findItems(attrName, attrValue, list);
                items.forEach(function(item) {
                    var row = kendoGrid.element.find("tr[data-uid=" + item.uid + "]")[0];
                    row.className += " " + className;
                })
            }

            function expandItem(kendoTree,item){
                if(!angular.isDefined(item.ParentLocationId) || item.ParentLocationId ==null){
                    return;
                }
                var items=kendoTree.dataItems();
                var parent=findItems("LocationId",item.ParentLocationId,items)[0];
                expandItem(kendoTree,parent);
                var parentRow = kendoTree.element.find("tr[data-uid=" + parent.uid + "]");
                kendoTree.expand(parentRow);
            }

            function findItems(attrName, attrValue, items) { //returns the items in the list with matching attribute value
                var result = [];
                for (var i = 0; i < items.length; i++) {
                    if (items[i][attrName] == attrValue) {
                        result.push(items[i]);
                    }
                }
                return result;
            }
        }
    ////////////////////////////////////////////////////


    //////////////////////CODE//////////////////////////
        userVM.date = new Date().toJSON();
        userVM.loading=false;
        userVM.gridData = resolvedData.locations.data;
        userVM.designationsLookup = resolvedData.Designations.data;
        userVM.usersLookup = resolvedData.Users.data;
        userVM.Devices = resolvedData.Devices.data;
        if (angular.isDefined(resolvedData.User.data)) {
            userVM.vm = resolvedData.User.data;
            userVM.EndDateString = new Date(userVM.vm.EffectiveEndDate);
            userVM.StartDateString = new Date(userVM.vm.EffectiveStartDate);
            userVM.vm.LocationName = userVM.getLocationName(userVM.gridData,userVM.vm.LocationId);
        }
        else {
            userVM.vm = resolvedData.User;
            userVM.EndDateString = userVM.date;
            userVM.StartDateString = userVM.date;
            userVM.onStartDateSelected(userVM.StartDateString)
            userVM.onEndDateSelected(userVM.EndDateString)
        }
        userVM.readonly = false;
        userVM.StartDateReadonly = false;
        userVM.EndDateReadonly = false;
        userVM.showStatus = true;
        if (userVM.vm.EffectiveEndDate < userVM.date) 
            userVM.vm.status = "inactive";
        else if (angular.isDefined(userVM.vm.TmxUserDevice)) 
            userVM.vm.status = "active";
    // if(angular.isDefined(userVM.vm.TmxUserDevice.UserId))
        userVM.lookup = {};
        lookupService.getUserTypes().then(function(types) {
            types.forEach(function(type) {
                type.HiddenValue = type.LookupId;
            });
            userVM.lookup.type = types;
        });
        userVM.lookup.status = [
            {
                HiddenValue: "active",
                VisibleValue: "Active",
            }, 
            {
                HiddenValue: "inactive",
                VisibleValue: "Inactive",
            }
        ];
        userVM.lookup.users = resolvedData.Users.data;
        userVM.currentStatus = userVM.getStatus();

        userVM.columns = LocationService.gridColumn;
        userVM.columns.push({
            field: "LocationTypeLkp",
            title: "Type",
            template: "{{LocationDialogCtrl.getLookupName(#=LocationTypeLkp#)}}"
        });
        userVM.updateDevicePhoneNumber(userVM.vm.DeviceId);
    ////////////////////////////////////////////////////
        userVM.page = dynamicform.tmxPage('My Custom Page');
    }
})();
